/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRaglV1TransactionEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_RAGL_V1_TRANSACTION_EVENT_ENTITY_NAME = 'ixc.ragl.v1.TransactionEvent';
export const ixcRaglV1TransactionEventEntity = new schema.Entity<IxcRaglV1TransactionEvent>(IXC_RAGL_V1_TRANSACTION_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        posted: new schema.Object({
            assets: [new schema.Object({
                    asset: ixcAssetsV1AssetStateEntity
                })]
        })
    })
}, { idAttribute: (entity: IxcRaglV1TransactionEvent) => `${entity.metadata?.eventId}` });

